import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../../hooks/useContainer';

const useHttpRequestEvaluationUpdate = () => {
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (id: string, updateReason?: string, setRefresh?: React.Dispatch<React.SetStateAction<number>>) => {
        const { exec, abort } = userApi.requestEvaluationUpdate({
            params: {
                id,
            },
            body: {
                updateReason,
            },
            onSuccess: () => {
                toastHandler.push('success', 'Evaluation Update Request', 'Evaluation update request successfuly sent');
                setRefresh && setRefresh(prev => prev + 1);
            },
            onError: error => {
                console.log(error);
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpRequestEvaluationUpdate;
